export enum HeronReportStatus {
    Pending = 'pending',
    InProgress = 'in-progress',
    Processed = 'processed',
    Succeeded = 'succeeded',
    Failed = 'failed',
    Canceled = 'canceled',
}
